const hubs = [
  {
    name: 'Western Australia — Pilbara',
    description: "The Pilbara's combination of world-class solar, wind, and existing export infrastructure makes it the centrepiece of Australia's hydrogen export ambition. Projects from Fortescue Future Industries, CWP Global's Asian Renewable Energy Hub, and H2TAS are targeting hundreds of GW of electrolyser capacity.",
    tag: 'Export powerhouse',
    tagColor: 'bg-accent-100 text-accent-800',
    icon: 'ri-sun-line',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    name: 'South Australia — Port Bonython',
    description: "SA's Hydrogen Jobs Plan includes a government-owned electrolyser and storage facility at Port Bonython. The state has mandated 100% renewable electricity by 2027 — creating natural surplus generation ideal for green hydrogen production.",
    tag: '100% RE target',
    tagColor: 'bg-primary-100 text-primary-700',
    icon: 'ri-landscape-line',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    name: 'Victoria — Port Kembla & Bell Bay',
    description: "The Port Kembla hydrogen hub is targeting Japanese and Korean export markets. Bell Bay Powerfuels in Tasmania (developed by Grange Resources) is developing green hydrogen and ammonia from abundant Tasmanian renewable energy.",
    tag: 'Japan & Korea export',
    tagColor: 'bg-secondary-100 text-secondary-700',
    icon: 'ri-ship-2-line',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
  {
    name: 'Queensland — Central QLD Hydrogen Project',
    description: "Queensland's Central Queensland Hydrogen Project (CQ-H2) is one of the largest proposed green hydrogen projects globally, targeting 2 million tonnes of green hydrogen per year from the state's excellent solar and wind resources.",
    tag: '2Mt/yr target',
    tagColor: 'bg-accent-100 text-accent-800',
    icon: 'ri-flashlight-line',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
];

const fundingItems = [
  {
    icon: 'ri-government-line',
    name: 'Hydrogen Headstart Program',
    amount: '$2B',
    desc: 'Federal production incentive for early-stage green hydrogen projects',
    color: 'text-accent-700',
    bg: 'bg-accent-50',
  },
  {
    icon: 'ri-bank-line',
    name: 'ARENA Hydrogen Grants',
    amount: '$500M+',
    desc: 'Project development, R&D, and feasibility studies for hydrogen innovation',
    color: 'text-primary-600',
    bg: 'bg-primary-50',
  },
  {
    icon: 'ri-building-line',
    name: 'CEFC Hydrogen Finance',
    amount: 'Concessional',
    desc: 'Low-cost debt finance for commercially viable hydrogen projects',
    color: 'text-secondary-600',
    bg: 'bg-secondary-50',
  },
];

export default function HydrogenOpportunity() {
  return (
    <section className="bg-background-100/50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-50 border border-accent-200/60 mb-5">
            <i className="ri-map-2-line text-accent-700 text-sm"></i>
            <span className="text-xs font-semibold text-accent-800 tracking-wide uppercase whitespace-nowrap">Australia&rsquo;s Hydrogen Opportunity</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4">
            Australia&rsquo;s Major Hydrogen Hubs<br className="hidden md:block" /> &amp; Export Projects
          </h2>
          <p className="text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Australia&rsquo;s National Hydrogen Strategy identifies the country as a globally competitive green hydrogen exporter. Major projects are underway in every state.
          </p>
        </div>

        {/* Hubs grid */}
        <div className="grid sm:grid-cols-2 gap-5 md:gap-6 mb-14">
          {hubs.map((hub) => (
            <div key={hub.name} className="bg-background-50 rounded-2xl p-6 border border-background-200/70 hover:border-accent-200 transition-all duration-200">
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-11 h-11 rounded-xl ${hub.bg} flex items-center justify-center shrink-0`}>
                  <i className={`${hub.icon} text-lg ${hub.color}`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1 flex-wrap">
                    <h3 className="font-heading text-sm font-bold text-foreground-950">{hub.name}</h3>
                    <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap ${hub.tagColor}`}>{hub.tag}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{hub.description}</p>
            </div>
          ))}
        </div>

        {/* Funding section */}
        <div className="bg-foreground-950 rounded-2xl p-7 md:p-10">
          <div className="text-center mb-8">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-2">Government Funding &amp; Incentives</h3>
            <p className="text-sm text-white/60">Australia&rsquo;s government has committed substantial funding to support hydrogen project development at every stage.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {fundingItems.map((item) => (
              <div key={item.name} className="text-center">
                <div className={`w-12 h-12 rounded-xl ${item.bg} flex items-center justify-center mx-auto mb-3`}>
                  <i className={`${item.icon} text-xl ${item.color}`}></i>
                </div>
                <div className="font-heading text-2xl font-extrabold text-white mb-1">{item.amount}</div>
                <div className="text-sm font-semibold text-white/80 mb-2">{item.name}</div>
                <p className="text-xs text-white/50 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}